import React from "react";
import { IconButton } from "@mui/material";

export interface ToolbarButtonProps {
  onClick: () => void;
  isActive?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

/** A small icon button used inside the mention editor's formatting toolbar. */
const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  onClick,
  isActive = false,
  disabled = false,
  children,
  style,
}) => {
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      size="small"
      sx={{
        marginLeft: 0,
        borderRadius: "4px",
        padding: "4px",
        minWidth: "32px",
        height: "32px",
        backgroundColor: isActive ? "action.selected" : "transparent",
        color: isActive ? "text.primary" : "inherit",
        "&:hover": {
          backgroundColor: "action.hover",
        },
        ...style,
      }}
    >
      {children}
    </IconButton>
  );
};

export default ToolbarButton;
